import * as React from 'react';

import SVGBase from '../svg-base/svg-base';

export interface TickProps {
    fill?: string;
    title?: string;
    height?: string;
    width?: string;
    viewBox?: string;
}

const Tick: React.FunctionComponent<React.PropsWithChildren<TickProps>> = ({
    fill,
    title,
    height,
    width,
    ...rest
}): any => (
    <SVGBase viewBox="0 0 515.556 515.556" height={height} width={width} title={title} fill={fill} {...rest}>
        <path d="m0 274.226 176.549 176.886 339.007-338.672-48.67-47.997-290.337 290-128.553-128.552z" />
    </SVGBase>
);

export default Tick;
